import { render, staticRenderFns } from "./ReportingOrCriteria.vue?vue&type=template&id=b17e2f44&scoped=true"
import script from "./ReportingOrCriteria.vue?vue&type=script&lang=js"
export * from "./ReportingOrCriteria.vue?vue&type=script&lang=js"
import style0 from "./ReportingOrCriteria.vue?vue&type=style&index=0&id=b17e2f44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b17e2f44",
  null
  
)

export default component.exports